export enum ModalLayout {
  default = 'default',
  large = 'large',
}
